import {
	CHECK_LAWSYS_FIRM_BANK_ACCOUNT_VALIDITY,
	CHECK_LAWSYS_FIRM_BANK_ACCOUNT_VALIDITY_FAILED,
	CHECK_LAWSYS_FIRM_BANK_ACCOUNT_VALIDITY_SUCCESS,
	FAILED_TO_RECEIVE_LAWSYS_FIRM_GROUP,
	RECEIVE_LAWSYS_FIRM_GROUP,
	RECEIVE_LAWSYS_FIRMS,
	RECEIVE_LAWSYS_FIRMS_FILTERED,
	RECEIVE_LAWSYS_FIRMS_WITH_AGENTS,
	REQUEST_LAWSYS_FIRM_GROUP,
	REQUEST_LAWSYS_FIRMS,
	REQUEST_LAWSYS_FIRMS_FILTERED,
	REQUEST_LAWSYS_FIRMS_WITH_AGENTS,
	CHANGE_LAWSYS_FIRM_STATE
} from "./index";
import {actionCreator} from "../helpers/functions";

export const checkLawsysFirmBankAccountValidity = actionCreator(CHECK_LAWSYS_FIRM_BANK_ACCOUNT_VALIDITY);
export const checkLawsysFirmBankAccountValiditySuccess = actionCreator(CHECK_LAWSYS_FIRM_BANK_ACCOUNT_VALIDITY_SUCCESS);
export const checkLawsysFirmBankAccountValidityFailed = actionCreator(CHECK_LAWSYS_FIRM_BANK_ACCOUNT_VALIDITY_FAILED);

//action that requests lawsys firm group
export function requestLawsysFirmGroup(lawsysId) {
	return {
		type: REQUEST_LAWSYS_FIRM_GROUP,
		payload: lawsysId
	}
}

//action that receives lawsys firm group
export function receiveLawsysFirmGroup(group) {
	return {
		type: RECEIVE_LAWSYS_FIRM_GROUP,
		payload: group
	}
}

//action that failed to receive lawsys firm group
export function failedToReceiveLawsysFirmGroup(response) {
	return {
		type: FAILED_TO_RECEIVE_LAWSYS_FIRM_GROUP,
		payload: response
	}
}

export function requestLawsysFirms(token){
	return {
		type: REQUEST_LAWSYS_FIRMS,
		payload: token
	}
}

export function receiveLawsysFirms(lawSysAgents){
	return {
		type: RECEIVE_LAWSYS_FIRMS,
		payload: lawSysAgents
	}
}

export function requestLawsysFirmsFiltered(payload){
	return {
		type: REQUEST_LAWSYS_FIRMS_FILTERED,
		payload: payload
	}
}

export function receiveLawsysFirmsFiltered(lawSysAgents){
	return {
		type: RECEIVE_LAWSYS_FIRMS_FILTERED,
		payload: lawSysAgents
	}
}

export function requestLawsysFirmsWithAgents(token){
	return {
		type: REQUEST_LAWSYS_FIRMS_WITH_AGENTS,
		payload: token
	}
}

export function receiveLawsysFirmsWithAgents(lawSysAgents){
	return {
		type: RECEIVE_LAWSYS_FIRMS_WITH_AGENTS,
		payload: lawSysAgents
	}
}

export function changeLawsysFirmState(key, value){
	return {
		type:CHANGE_LAWSYS_FIRM_STATE,
		payload: {
			key,
			value
		}
	}
};